import GenderType from "../../../domain/fundamentals/gender/GenderType";

export const toGenderType = (source: string): GenderType => {
  switch (source) {
    default:
    case GenderType.NOT_KNOWN:
      return GenderType.NOT_KNOWN;
    case GenderType.MALE:
      return GenderType.MALE;
    case GenderType.FEMALE:
      return GenderType.FEMALE;
    case GenderType.NOT_APPLICABLE:
      return GenderType.NOT_APPLICABLE;
  }
};